var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.root && _vm.isRender)?_c('vue2-org-tree',{attrs:{"data":_vm.root,"horizontal":true,"collapsable":true,"renderContent":_vm.renderContent},on:{"onExpand":_vm.onExpand,"onNodeClick":_vm.onNodeClick}}):_vm._e(),_vm._v(" "),(
          _vm.isEnable &&
            _vm.selectedNodeType ===
              _vm.PROCESS_TREE.NODE_TYPE.PROCESS_NODE
        )?_c('vbdi-process-moreinfo-cxlcanhan',{attrs:{"isOpen":_vm.isOpen,"process":_vm.selectedNode.vbOutgoingProcess},on:{"closeDialog":function($event){_vm.isOpen = false},"closed":function($event){_vm.isEnable = false}}}):(
          _vm.isEnable &&
            _vm.selectedNodeType === _vm.PROCESS_TREE.NODE_TYPE.BANHANH_NODE
        )?_c('vbdi-process-moreinfo-banhanh',{attrs:{"isOpen":_vm.isOpen,"docId":_vm.docId},on:{"closeDialog":function($event){_vm.isOpen = false},"closed":function($event){_vm.isEnable = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5db545","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-out/components/LuongXuLy.vue
// module id = null
// module chunks = 